import type { ReactNode } from "react";
import { cx } from "./ui";

const TONES = {
  muted: "bg-surface-2 text-ink-2",
  accent: "bg-accent-chip text-accent-text",
  good: "bg-good-soft text-good",
  warn: "bg-warn-soft text-warn",
  bad: "bg-bad-soft text-bad",
};

export function Chip({ tone = "muted", children }: { tone?: keyof typeof TONES; children: ReactNode }) {
  return <span className={cx("inline-flex items-center rounded-full px-2 h-5 text-xs font-medium whitespace-nowrap", TONES[tone])}>{children}</span>;
}

export function Card({ title, actions, children, className }: { title?: ReactNode; actions?: ReactNode; children: ReactNode; className?: string }) {
  return (
    <section className={cx("bg-surface border border-line rounded-xl", className)}>
      {(title || actions) && (
        <div className="flex items-center justify-between gap-2 px-4 pt-3 pb-2">
          {title && <h2 className="text-sm font-semibold text-ink">{title}</h2>}
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      )}
      <div className="px-4 pb-4">{children}</div>
    </section>
  );
}

export function Field({ label, hint, children, htmlFor }: { label: string; hint?: string; children: ReactNode; htmlFor?: string }) {
  return (
    <div>
      <label htmlFor={htmlFor} className="block text-sm font-medium text-ink-2 mb-1">
        {label}
      </label>
      {children}
      {hint && <p className="text-xs text-muted mt-1">{hint}</p>}
    </div>
  );
}

export const inputCls = "w-full h-9 rounded-lg border border-line bg-surface px-3 text-sm text-ink placeholder:text-muted";
